// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-7dbfa472]{font-size:30px;padding:5px;color:#4abca5}.caption[data-v-7dbfa472]{font-size:20px;padding:5px;color:#837d89}.content-box[data-v-7dbfa472]{margin:60px 25px 0 25px;text-align:center}.ons-card[data-v-7dbfa472]{-webkit-box-shadow:rgba(74,188,165,.35) 0 5px 15px;box-shadow:0 5px 15px rgba(74,188,165,.35);text-align:center;background-color:rgba(131,125,137,.1);border-color:transparent}.button[data-v-7dbfa472]{background-color:#4abca5;color:#fff;text-align:center}", ""]);
// Exports
module.exports = exports;
